import { useIsDarkTheme } from './Theme';

const Logo = ({ className }: { className: string }) => {
  const isDark = useIsDarkTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 637.9 280.12"
      className={className}
    >
      <defs>
        <style>{`
          .cls-1 {
            fill: ${isDark ? '#9755ff' : '#9755ff'};
            transition: fill 0.3s ease;
          }
          .cls-2 {
            fill: ${isDark ? '#ff8270' : '#ff8270'};
            transition: fill 0.3s ease;
          }
        `}</style>
      </defs>
      <g id="Capa_1" data-name="Capa 1">
        <g>
          <path
            className="cls-1"
            d="M188.64,15.79v44.89h-60.22v215.7h-49.87V60.68H0V15.79h188.64Z"
          />
          <path
            className="cls-2"
            d="M397.69,200.74c0,26.6-7.48,45.86-22.44,57.77-14.96,11.92-38.65,17.87-71.07,17.87h-101.82V15.79h101.82c29.36,0,50.22,4.99,62.55,14.96,12.33,9.97,18.5,27.01,18.5,51.12,0,16.35-2.5,28.82-7.48,37.41-4.99,8.59-14.13,14.82-27.43,18.7,15.79,2.77,27.64,9.35,35.53,19.74,7.9,10.39,11.84,24.73,11.84,43.02ZM339.09,88.94c0-11.91-2.56-20.16-7.69-24.73-5.13-4.57-14.2-6.86-27.22-6.86h-51.95v67.33h51.95c12.47,0,21.4-2.77,26.81-8.31,5.4-5.54,8.1-14.68,8.1-27.43ZM349.48,197.41c0-12.74-3.39-21.61-10.18-26.6-6.79-4.99-18.5-7.48-35.12-7.48h-51.95v69.82h51.95c16.62,0,28.33-2.63,35.12-7.9,6.79-5.26,10.18-14.55,10.18-27.85Z"
          />
          <path
            className="cls-2"
            d="M473.74,41.98h-51.12V0h9.14c23.18,0,41.98,18.79,41.98,41.98h0ZM472.49,276.38h-48.21V71.07h48.21v205.31Z"
          />
          <path
            className="cls-2"
            d="M637.9,231.49v41.15c-4.72,1.94-11.29,3.67-19.74,5.19-8.46,1.52-16.14,2.29-23.07,2.29-26.33,0-45.16-5.75-56.52-17.25-11.36-11.49-17.04-30.68-17.04-57.56v-93.93h-27.43v-40.31h28.68l6.65-49.04h40.32v49.04h65.67v40.31h-65.67v92.27c0,12.2,2.63,20.51,7.9,24.94,5.26,4.44,14.68,6.65,28.26,6.65,4.71,0,10.25-.35,16.63-1.04,6.37-.69,11.49-1.59,15.38-2.7Z"
          />
        </g>
      </g>
    </svg>
  );
};

export default Logo;
